import { fetchApi } from '@/api/http'

const KEY_ACTIVE = 'agendamentos-app:profissional:active'
const KEY_PROF_DATA = 'agendamentos-app:profissional:data'
const LEGACY_TOKEN_KEY = 'agendamentos-app:profissional:token'

export interface ProfissionalSession {
  id: number
  nome: string
  email: string | null
  especialidade: string | null
}

function clearLegacyToken(): void {
  try {
    localStorage.removeItem(LEGACY_TOKEN_KEY)
  } catch {
    /* ignore */
  }
}

export function getProfissionalToken(): string | null {
  return null
}

export function getProfissionalData(): ProfissionalSession | null {
  try {
    const raw = localStorage.getItem(KEY_PROF_DATA)
    if (!raw) return null
    const parsed = JSON.parse(raw) as ProfissionalSession
    if (!parsed || typeof parsed.id !== 'number') return null
    return parsed
  } catch {
    return null
  }
}

export function isProfissional(): boolean {
  try {
    clearLegacyToken()
    return sessionStorage.getItem(KEY_ACTIVE) === '1'
  } catch {
    return false
  }
}

export function markProfissionalSessionActive(): void {
  try {
    sessionStorage.setItem(KEY_ACTIVE, '1')
    clearLegacyToken()
  } catch {
    /* ignore */
  }
}

export function setProfissional(_token: string | null, data: ProfissionalSession): void {
  try {
    sessionStorage.setItem(KEY_ACTIVE, '1')
    localStorage.setItem(KEY_PROF_DATA, JSON.stringify(data))
    clearLegacyToken()
  } catch {
    /* ignore */
  }
}

export async function logoutProfissionalApi(): Promise<void> {
  try {
    await fetchApi('/api/profissional/logout', { method: 'POST' })
  } catch {
    /* ignore */
  }
}

export function logoutProfissional(): void {
  try {
    sessionStorage.removeItem(KEY_ACTIVE)
    localStorage.removeItem(KEY_PROF_DATA)
    clearLegacyToken()
  } catch {
    /* ignore */
  }
  void logoutProfissionalApi()
}
